"use strict";
var React = require("react");
var AddUserModal = require("./AddUserModal");
var Button = require("react-bootstrap").Button;
var EditUserModal = require("./EditUserModal");
var DeleteUserModal = require("./DeleteUserModal");
var EditPasswordModal = require("./EditPasswordModal");
var _ = require("underscore");
var CompanyStore = require("../../../stores/CompanyStore");
var CompanyActions = require("../../../actions/CompanyActions");

var UserItem = React.createClass({
    getInitialState(){
        return {
          showEditModal: false,
          showDeleteModal: false,
          showPasswordModal: false
        };
    },
    closeEdit(){
        this.setState({ showEditModal: false });
    },
    openEdit(){
        this.setState({ showEditModal: true });
    },
    closeDelete(){
        this.setState({ showDeleteModal: false });
    },
    openDelete(){
        this.setState({ showDeleteModal: true });
    },
    closePassword(){
        this.setState({ showPasswordModal: false });
    },
    openPassword(){
        this.setState({ showPasswordModal: true });
    },
    render: function() {
        return (
          <tr className="settings-table-row">
            <td className="settings-table-column">
              <span>{this.props.user.username}</span>
            </td>
            <td className="settings-table-column">
              <span>{this.props.user.first_name + " " + this.props.user.last_name}</span>
            </td>
            <td className="settings-table-column">
              <span>{this.props.user.is_staff === true ? "Stjórnandi" : "Starfsmaður"}</span>
            </td>
            <td className="settings-table-column">
              <span>{this.props.user.is_active === true ? "Virkur" : "Óvirkur"}</span>
            </td>
            <td className="settings-table-column buttons">
              {(this.state.showEditModal) &&
                <EditUserModal
                  user={this.props.user}
                  show={this.state.showEditModal}
                  onHide={this.closeEdit}
                />
              }
              {(this.state.showDeleteModal) &&
                <DeleteUserModal
                  user={this.props.user}
                  show={this.state.showDeleteModal}
                  onHide={this.closeDelete}
                />
              }
              {(this.state.showPasswordModal) &&
                <EditPasswordModal
                  user={this.props.user}
                  show={this.state.showPasswordModal}
                  onHide={this.closePassword}
                />
              }

              {(this.props.user.id !== localStorage.getItem('userId')) ?
                <div>
                    <button className="btn btn-default pull-right" title="Bæta við hérna" onClick={this.openDelete}>
                        <span className="md md-delete"/>
                    </button>
                    <button className="btn btn-default pull-right" title="Breyta lykilorði" onClick={this.openPassword}>
                        <span className="md md-lock"></span>
                    </button>
                    <button className="btn btn-default pull-right" title="Breyta" onClick={this.openEdit}>
                        <span className="md md-mode-edit"/>
                    </button>
                </div> :
                <div>
                  <button className="btn btn-default pull-right" title="Breyta lykilorði" onClick={this.openPassword}>
                    <span className="md md-lock"></span>
                  </button>
                </div>
              }
            </td>
          </tr>
        );
    }
});

var UsersTab = React.createClass({
    getInitialState(){
        var storeState = CompanyStore.getState();
        return {
            users: storeState.users,
            showModal: false
        };
    },
    componentDidMount: function() {
        CompanyStore.listen(this.onChange);
    },
    componentWillUnmount: function() {
        CompanyStore.unlisten(this.onChange);
    },
    onChange: function() {
        var storeState = CompanyStore.getState();
        this.setState({ users: storeState.users });
    },
    close(){
        this.setState({ showModal: false });
    },
    open(){
        this.setState({ showModal: true });
    },
    mapUsers(user) {
        return (
            <UserItem key={user.id} user={user} />
        );
    },
    nameSort(a, b) {
        if(a.name > b.name) {
            return 1;
        } else if(b.name > a.name) {
            return -1;
        } else {
            return 0;
        }
    },
    render: function() {
        var users = this.state.users

        if (users && !_.isEmpty(users)) {
            users.sort(function(a, b) {
                if(a.username > b.username) {
                    return 1;
                } else if(b.username > a.username) {
                    return -1;
                } else {
                    return 0;
                }
            });
        }

        return(
            <div className="row">
                <div className="settings-header col-xs-12">
                    <h3>Notendur</h3>
                    <AddUserModal show={this.state.showModal} onHide={this.close}/>
                    <Button className="page-scroll btn btn-xl" onClick={this.open}>Bæta við notanda</Button>
                </div>
                <div className="settings-body col-xs-12">
                    <div className="row">
                        <div className="table-responsive">
                            <table className="table table-hover">
                                <thead>
                                    <tr>
                                        <td className="settings-table-column column-title">Notandanafn</td>
                                        <td className="settings-table-column column-title">Nafn</td>
                                        <td className="settings-table-column column-title">Tegund</td>
                                        <td className="settings-table-column column-title">Staða</td>
                                        <td className="settings-table-column buttons"></td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {_.map(users, this.mapUsers)}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
});

module.exports = UsersTab;



// WEBPACK FOOTER //
// ./app/scripts/ui/Settings/Users/UsersTab.react.js